import React, { useState, useEffect } from "react";
import AppBarAuditoria from "../components/AppBarAuditoria";
import AuditoriaView from "../views/AuditoriaView";
import LiquidacionView from "../views/LiquidacionView";
import PeriodosAuditoriaView from "../views/PeriodosAuditoriaView";
import ListasHonorariosView from "../views/ListasHonorariosView";
import AjustesView from "../views/AjustesView";
import RefacturarDerivacionesView from "../views/RefacturarDerivacionesView";
import dayjs from "dayjs";
import AuditoriaActions from "../components/AuditoriaActions";
import LiquidacionActions from "../components/LiquidacionActions";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ListasHonorariosActions from "../components/ListasHonorariosActions";
import IsoIcon from "@mui/icons-material/Iso";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { ModeloGetUrlJson } from "../../ModeloCrud";
import crypto from "../../Crypto";
import { useAuditoria } from "../contexts/AuditoriaContext";
import ListAltIcon from "@mui/icons-material/ListAlt";

const AuditoriaLayout = () => {
  const [vista, setVista] = useState("auditoria");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [allCentros, setAllCentros] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [title, setTitle] = useState("Auditar período");

  const {
    auditoriaActivaFecha,
    auditoriaActivaId,
    auditoriaPantalla,
    periodoCerrado,
    modoAuditoria,
    updateAuditoria,
  } = useAuditoria();

  useEffect(() => {
    const fetchInitData = async () => {
      const response = await ModeloGetUrlJson(
        "auditoria",
        null,
        "activa",
        null
      );
      console.log("Respuesta de auditoria:", response);

      if (response.error === false) {
        const fecha = new Date(
          response.listado.anio,
          response.listado.mes - 1,
          1
        );
        const periodoCerrado = response.listado.cerrada === 1;
        const modoAuditoria = true;

        updateAuditoria({
          auditoriaActivaId: response.listado.id,
          auditoriaPantalla: response.listado[0],
          auditoriaActivaFecha: fecha,
          selectedDate: fecha,
          periodoCerrado,
          modoAuditoria,
        });

        setIsDataLoaded(true);
      }
    };

    if (auditoriaActivaId === null) {
      fetchInitData();
    }
  }, [auditoriaActivaId, updateAuditoria]);

  useEffect(() => {
    if (!auditoriaPantalla) return;

    const { id, cerrada } = auditoriaPantalla;
    const isEqual = auditoriaActivaId === id;
    const isPeriodoCerrado = cerrada === 1;

    if (modoAuditoria !== isEqual || periodoCerrado !== isPeriodoCerrado) {
      updateAuditoria({
        periodoCerrado: isPeriodoCerrado,
        modoAuditoria: isEqual,
      });
    }
  }, [
    auditoriaActivaId,
    auditoriaPantalla,
    updateAuditoria,
    modoAuditoria,
    periodoCerrado,
  ]);

  useEffect(() => {
    const centros = crypto.decryptDataStorage("centros") || [];
    setAllCentros(centros);
  }, []);

  return (
    <Box>
      {["auditoria", "periodos"].includes(vista) && (
        <AppBarAuditoria allCentros={allCentros} />
      )}
      <Box
        sx={{
          maxWidth: "lg",
          mx: "auto",
          px: 3,
          mt: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        {/* Izquierda: menú + período */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Button
            variant="contained"
            onClick={(event) => setAnchorEl(event.currentTarget)}
            endIcon={<MoreVertIcon />}
          >
            Más opciones
          </Button>
          <Typography variant="body1" sx={{ fontWeight: "bold", ml: 5 }}>
            {title}
          </Typography>

          {/* Menú desplegable */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem
              onClick={() => {
                setVista("auditoria");
                setTitle("Auditar período");
                setAnchorEl(null);
              }}
            >
              <ContentPasteSearchIcon color="primary" sx={{ mr: 1 }} />
              Auditar período
            </MenuItem>
            <MenuItem
              onClick={() => {
                setVista("liquidacion");
                setTitle("Liquidar período");
                setAnchorEl(null);
              }}
            >
              <PictureAsPdfIcon color="primary" sx={{ mr: 1 }} />
              Liquidar período
            </MenuItem>
            <MenuItem
              onClick={() => {
                setVista("periodos");
                setTitle("Períodos de auditoría");
                setAnchorEl(null);
              }}
            >
              <EventAvailableIcon color="primary" sx={{ mr: 1 }} />
              Activar período
            </MenuItem>
            <MenuItem
              onClick={() => {
                setVista("listas");
                setTitle("Listas de honorarios");
                setAnchorEl(null);
              }}
            >
              <RequestQuoteIcon color="primary" sx={{ mr: 1 }} />
              Listas de honorarios
            </MenuItem>
            <MenuItem
              onClick={() => {
                setVista("ajustes");
                setTitle("Ajustes");
                setAnchorEl(null);
              }}
            >
              <IsoIcon color="primary" sx={{ mr: 1 }} />
              Ajustes
            </MenuItem>
            <MenuItem
              onClick={() => {
                setVista("refacturacion");
                setTitle("Refacturar derivaciones");
                setAnchorEl(null);
              }}
            >
              <PublishedWithChangesIcon color="primary" sx={{ mr: 1 }} />
              Refacturar derivaciones
            </MenuItem>
          </Menu>
        </Box>

        {/* Derecha: acciones contextualizadas */}
        {vista === "auditoria" && <AuditoriaActions />}
        {vista === "liquidacion" && <LiquidacionActions />}
        {vista === "listas" && <ListasHonorariosActions />}
      </Box>
      {/* Contenido según la vista */}
      <Box mt={1} px={3}>
        {vista === "auditoria" && <AuditoriaView />}

        {vista === "liquidacion" && (
          <Box maxWidth="lg" mx="auto">
            <LiquidacionView />
          </Box>
        )}

        {vista === "periodos" && (
          <Box maxWidth="lg" mx="auto">
            <PeriodosAuditoriaView />
          </Box>
        )}

        {vista === "listas" && (
          <Box maxWidth="lg" mx="auto">
            <ListasHonorariosView />
          </Box>
        )}
        {vista === "ajustes" && (
          <Box maxWidth="lg" mx="auto">
            <AjustesView />
          </Box>
        )}
        {vista === "refacturacion" && (
          <Box maxWidth="lg" mx="auto">
            <RefacturarDerivacionesView />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AuditoriaLayout;
